const TOP_GRD_COLOR_NAME = Object.freeze({
  grayLight: '#BEBEBE',
  grayDark: '#535353',
  black: '#252629',
  purpleLight: '#EDD9FF',
  purple: '#AF6DD1',
  purpleDark: '#5F1C81',
  greenLight: '#B8E986',
  green: '#4E9201',
  blueLight: '#74A6FA',
  blue: '#3C78FD',
  blueMatte: '#3B5998',
  blueNavy: '#002474',
  yellow: '#FFF362',
  orange: '#FA9F1D',
  pinkLight: '#CB91FF',
  red: '#E32E45',
  redDeep: '#9E034C',
  redDark: '#7F033E',
  defaultGreen: '#449973', // Holiday
  defaultPurple: '#9F23E1', // Meeting with Slick
});

export default TOP_GRD_COLOR_NAME;
